import { render, staticRenderFns } from "./CommentSubmitForm.vue?vue&type=template&id=2f47591e&"
import script from "./CommentSubmitForm.vue?vue&type=script&lang=js&"
export * from "./CommentSubmitForm.vue?vue&type=script&lang=js&"
import style0 from "./CommentSubmitForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports